<template>
  <section class="section">
    <div class="section-body">
      <div class="card" v-if="!isEdit">
        <div class="card-header">
          <v-icon color="pink">search</v-icon>
          <h4>{{ $t("messages.general.searchShowInfo") }}</h4>
        </div>
        <div class="card-body">
          <v-card width="100%">
            <v-row>
              <v-col
                cols="10"
                style="padding-top: 0; padding-bottom: 0; padding-right: 0;text-align: right;"
              >
                <p style="color: red; margin: 0">*</p>
              </v-col>
              <v-col
                style="padding-top: 0; padding-bottom: 0; padding-right: 5px;"
              >
                <p style="margin: 0">{{ $t("messages.general.reqFields") }}</p>
              </v-col>
            </v-row>
          </v-card>
          <form>
            <!-- AcademicYear -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.academicYear") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <AcademicYear
                      :onChanged="onSelYearChanged"
                      :selectedVal="selYear"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Semester -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.semester") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Semester
                      :onChanged="onSelSemesterChanged"
                      :selectedVal="selSemester"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Level -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label
                      >{{ $t("messages.general.educationLvl") }}
                      <code style="background: none; box-shadow: none;"
                        >*</code
                      ></label
                    >
                  </div>
                  <div class="col no-margin-padding">
                    <Level
                      :onChanged="onSelLvlChanged"
                      :selectedVal="selLvl"
                      :disabled="false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- Faculty -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label>{{ $t("messages.general.faculty") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <Faculty
                      :onChanged="onSelFacultyChanged"
                      :selectedVal="selFaculty"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- classCode  -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label>{{ $t("messages.general.advisor") }}</label>
                  </div>
                  <div class="col no-margin-padding">
                    <div class="form-row">
                      <div
                        class="col no-margin-padding"
                        style="flex: 0 0 16em; padding-top: 0; padding-left: 5px; padding-right: 5px; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="input-group">
                            <div class="form-inline">
                              <div class="input-group-append">
                                <input
                                  type="text"
                                  class="form-control col mr-2"
                                  style="margin-right: 0px !important"
                                  v-model="advisorCode"
                                  @keypress="handleSearchAdvisorKey($event)"
                                />
                                <button
                                  type="button"
                                  class="btn btn-temp btn-lg"
                                  @click="handleSearchAdvisor()"
                                >
                                  <i class="fas fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="col no-margin-padding"
                        style="padding-left: 5px; padding-top: 0; padding-right: 0; padding-bottom: 0;"
                      >
                        <div class="form-group" style="margin-bottom: 0;">
                          <div class="form-inline">
                            <input
                              type="text"
                              class="form-control col mr-2"
                              style="margin-right: 0px !important"
                              disabled
                              v-model="advisorName"
                            />
                            <button
                              type="button"
                              class="btn btn-danger btn-lg"
                              @click="handleClrScreen()"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- period  -->
            <div class="form-row">
              <div class="col no-padding-bottom">
                <div class="information-detail-white">
                  <div class="col no-margin-padding" style="flex: 0 0 12em;">
                    <label>{{ $t("messages.general.periodRequest") }} </label>
                  </div>
                  <div class="col no-margin-padding">
                    <Period :onChanged="onSelPeriod" :selectedVal="selPeriod" />
                  </div>
                </div>
              </div>
            </div>
            <!-- Export Report Button -->
            <div
              class="form-row flex-column justify-content-center align-items-center mt-5"
            >
              <div class="form-group">
                <div class="form-inline">
                  <button
                    class="btn btn-primary btn-lg"
                    @click="handleExportReport('PDF')"
                    type="button"
                  >
                    {{ $t("messages.general.printReport") }} PDF</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-primary btn-lg"
                    @click="handleExportReport('EXCEL')"
                    type="button"
                  >
                    {{ $t("messages.general.printReport") }} EXCEL</button
                  >&nbsp;&nbsp;&nbsp;
                  <button
                    class="btn btn-light btn-lg"
                    type="button"
                    @click="clearAll()"
                  >
                    {{ $t("messages.general.clearScreen") }}</button
                  >&nbsp;&nbsp;&nbsp;
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- Error Dialog -->
      <v-dialog v-model="dialogError" max-width="600px">
        <v-card tile>
          <v-toolbar flat dense color="red darken-3">
            <v-icon color="red lighten-5">fa-exclamation-circle</v-icon>
            <v-toolbar-title style="color: #ffebee;"
              >&nbsp;{{ dialogErrorTitle }}</v-toolbar-title
            >
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogError = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark color="red accent-1">
            <br />
            <span style="color: red;">{{ errorText }}</span>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSearchAdvisor"
        hide-overlay
        scrollable
        max-width="80%"
      >
        <v-card tile>
          <v-toolbar flat dense>
            <v-icon>search</v-icon>
            <v-toolbar-title>{{
              $t("messages.general.selectDataCoorSched")
            }}</v-toolbar-title>
            <div class="flex-grow-1"></div>
            <v-toolbar-items>
              <v-btn icon @click="dialogSearchAdvisor = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-card-text dark>
            <form>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.identity") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgIdentity"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.fullname") }}</label>
                    </div>
                    <div class="col no-margin-padding">
                      <div>
                        <input
                          v-model="dlgFullname"
                          type="text"
                          class="form-control col mr-2"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col no-padding-bottom">
                  <div class="information-detail-white">
                    <div class="col no-margin-padding" style="flex: 0 0 10em;">
                      <label>{{ $t("messages.general.underFac") }}</label
                      ><code style="background: none; box-shadow: none;"
                        >*</code
                      >
                    </div>
                    <div class="col no-margin-padding">
                      <Faculty
                        :onChanged="onSelFacultyCourseChanged"
                        :selectedVal="selunderFac"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-row flex-column justify-content-center align-items-center mt-5"
              >
                <div class="form-group">
                  <div class="form-inline">
                    <button
                      class="btn btn-primary btn-lg"
                      type="button"
                      @click="handleAdvisorSearch()"
                    >
                      {{ $t("messages.general.search") }}</button
                    >&nbsp;&nbsp;&nbsp;
                    <button
                      class="btn btn-light btn-lg"
                      type="button"
                      @click="clearAdvisor()"
                    >
                      {{ $t("messages.general.clearScreen") }}</button
                    >&nbsp;&nbsp;&nbsp;
                  </div>
                </div>
              </div>
            </form>
            <v-card>
              <b-table
                bordered
                hover
                small
                responsive
                caption-top
                class="table table-striped text-center"
                :sort-by.sync="bTableAdvisor.sortBy"
                :sort-desc.sync="bTableAdvisor.sortDesc"
                :items="bTableAdvisor.items"
                :fields="bTableAdvisor.fields"
                :per-page="perPage"
                :current-page="currentPageProgram"
              >
                <template slot="table-caption">
                  <div class="float-left">
                    <b class="mr-2">{{
                      $t("messages.general.table.paginationinfo")
                    }}</b>
                    <b-form-select
                      v-model="perPage"
                      :options="perPageOptions"
                      size="sm"
                      style="width:70px"
                    />
                  </div>
                  <b-pagination
                    class="float-right"
                    size="sm"
                    :total-rows="bTableAdvisor.items.length"
                    v-model="currentPageProgram"
                    :per-page="perPage"
                  />
                  <div
                    v-if="bTableAdvisor.items.length > 0"
                    class="float-right data-table-page-info"
                  >
                    {{
                      Number(
                        currentPageProgram > 1
                          ? (currentPageProgram - 1) * perPage + 1
                          : currentPageProgram
                      ).toLocaleString()
                    }}
                    -
                    {{
                      Number(
                        currentPageProgram * perPage >
                          bTableAdvisor.items.length
                          ? bTableAdvisor.items.length
                          : currentPageProgram * perPage
                      ).toLocaleString()
                    }}
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableAdvisor.items.length).toLocaleString() }}
                  </div>
                  <div
                    v-if="bTableAdvisor.items.length <= 0"
                    class="float-right data-table-page-info"
                  >
                    0 - 0
                    {{ $t("messages.general.fromRecords") }}
                    {{ Number(bTableAdvisor.items.length).toLocaleString() }}
                  </div>
                </template>

                <template v-slot:cell(OFFICERCODE)="data">
                  <a
                    @click="handleSelectAdvisor(data.item, data.index)"
                    style="text-decoration: underline;"
                  >
                    {{ data.item.OFFICERCODE }}
                  </a>
                </template>

                <template slot="table-caption">
                  <div
                    style="position: absolute; bottom: -65px; width: 100%; height: 65px; padding-top: 10px; border-color: #fff; box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);"
                  >
                    <div class="float-left">
                      <b class="mr-2">{{
                        $t("messages.general.table.paginationinfo")
                      }}</b>
                      <b-form-select
                        v-model="perPage"
                        :options="perPageOptions"
                        size="sm"
                        style="width:70px"
                      />
                    </div>
                    <b-pagination
                      class="float-right"
                      size="sm"
                      :total-rows="bTableAdvisor.items.length"
                      v-model="currentPageProgram"
                      :per-page="perPage"
                      style="padding-top: 10px"
                    />
                    <div
                      v-if="bTableAdvisor.items.length > 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      {{
                        Number(
                          currentPageProgram > 1
                            ? (currentPageProgram - 1) * perPage + 1
                            : currentPageProgram
                        ).toLocaleString()
                      }}
                      -
                      {{
                        Number(
                          currentPageProgram * perPage >
                            bTableAdvisor.items.length
                            ? bTableAdvisor.items.length
                            : currentPageProgram * perPage
                        ).toLocaleString()
                      }}
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableAdvisor.items.length).toLocaleString() }}
                    </div>
                    <div
                      v-if="bTableAdvisor.items.length <= 0"
                      class="float-right data-table-page-info"
                      style="padding-top: 14px"
                    >
                      0 - 0
                      {{ $t("messages.general.fromRecords") }}
                      {{ Number(bTableAdvisor.items.length).toLocaleString() }}
                    </div>
                  </div>
                </template>
              </b-table>
            </v-card>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";

import AcademicYear from "@/components/Dropdown/AcademicYear";
import Semester from "@/components/Dropdown/Semester";
import Level from "@/components/Dropdown/Level.vue";
import Faculty from "@/components/Dropdown/Faculty.vue";
import Period from "@/components/Dropdown/Period.vue";
import EnrollProvider from "@/services/enroll_provider";
import MasterDataProvider from "@/services/masterData_provider";

const masterDataProvider = new MasterDataProvider();
const enrollProvider = new EnrollProvider();

export default {
  name: "rpterpreenrollbyinst",
  components: {
    AcademicYear,
    Semester,
    Level,
    Faculty,
    Period,
  },
  data() {
    return {
      selYear: 0,
      selSemester: 0,
      selLvl: 0,
      selFaculty: 0,
      isEdit: false,
      dialogError: false,
      errorText: "",
      dialogErrorTitle: "",
      selPeriod: "A",
      courseList: [],
      dialogSearchAdvisor: false,
      dlgIdentity: "",
      dlgFullname: "",
      advisorName: "",
      advisorCode: "",
      selunderFac: 0,
      // selFacultyCourse: 0,
      bTableAdvisor: {
        sortBy: "rowNumber",
        sortDesc: false,
        items: [],
        fields: [
          {
            key: "rowNumber",
            label: this.$t("messages.general.seqOrder"),
            thClass: "align-middle",
            thStyle: "width: 50px",
            sortable: true,
          },
          {
            key: "OFFICERCODE",
            label: this.$t("messages.general.identity"),
            thClass: "align-middle",
            thStyle: "width: 120px",
            sortable: true,
          },
          {
            key: "NAME",
            label: this.$t("messages.general.fullname"),
            thClass: "align-middle",
            thStyle: "width: 250px",
            tdClass: "text-left text-nowarp",
            sortable: true,
          },
          {
            key: "FACULTYNAME",
            label: this.$t("messages.general.underFac"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
          {
            key: "GENDER",
            label: this.$t("messages.general.gender"),
            thClass: "align-middle",
            thStyle: "width: 150px",
            tdClass: "text-center text-nowarp",
            sortable: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("application", {
      appInfo: "getUserInfo",
      token: "getToken",
      userId: "getUserId",
      mfuUserId: "getMfuUserId",
    }),
    currentLang: function() {
      return this.appInfo.currentLocale;
    },
  },
  mounted() {
    this.tokenHealthChk();
    this.togglePreLoader(true);
    this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
    this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
    this.selLvl = 3;
    this.togglePreLoader(false);
  },
  methods: {
    ...mapActions("application", ["togglePreLoader", "tokenHealthChk"]),
    onSelYearChanged(event) {
      this.selYear = parseInt(event.target.value);
    },
    onSelSemesterChanged(event) {
      this.selSemester = parseInt(event.target.value);
    },
    onSelLvlChanged(event) {
      this.selLvl = parseInt(event.target.value);
    },
    onSelFacultyChanged(event) {
      this.selFaculty = parseInt(event.target.value);
    },
    onSelPeriod(event) {
      this.selPeriod = parseInt(event.target.value);
    },
    onSelFacultyCourseChanged() {
      this.selunderFac = parseInt(event.target.value);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async handleExportReport(reportType) {
      if (this.selYear != 0 && this.selSemester != 0 && this.selLvl != -1) {
        this.togglePreLoader(true);
        const response = await axios.get(
          `${process.env.VUE_APP_API_ENDPOINT}report/rpterpreenrollbyinst`,
          {
            params: {
              acadyear: this.selYear,
              semester: this.selSemester,
              levelid: this.selLvl,
              facultyid: this.selFaculty,
              officerid: +this.advisorCode,
              period: this.selPeriod,
              lang: this.appInfo.currentLocale.toUpperCase(),
              report_type: reportType,
              file:
                "rpterpreenrollbyinst" +
                (reportType === "PDF" ? ".pdf" : ".xlsx"),
            },
          }
        );

        if (response.status === 200) {
          // Queue Report
          let isWaitAndContinue = true;
          let responseAfterCheckQueue = {};
          while (isWaitAndContinue) {
            console.log("checking..");
            const resultQueueStatus = await axios.get(
              `${process.env.VUE_APP_API_ENDPOINT}report/queue`,
              {
                params: {
                  queue_id: response.data.data.queue_id,
                },
              }
            );
            if (
              resultQueueStatus.status === 200 &&
              (resultQueueStatus.data.data.status !== "pending" &&
                resultQueueStatus.data.data.status !== "processing")
            ) {
              isWaitAndContinue = false;
              responseAfterCheckQueue = resultQueueStatus;
              break;
            }
            console.log("attemping to retry.");
            await this.sleep(3 * 1000);
          }

          if (responseAfterCheckQueue.data.data.status === "error") {
            this.dialogErrorTitle = "";
            this.dialogError = true;
            if (
              responseAfterCheckQueue.data.data.message.trim() ===
              "404_NOT_FOUND"
            ) {
              this.errorText = "Report no data found.";
            } else {
              this.errorText = responseAfterCheckQueue.data.data.message;
            }
          } else {
            // Download file
            const resultDownload = await axios.get(
              `${process.env.VUE_APP_API_ENDPOINT}report/queue/file`,
              {
                responseType: "blob",
                params: {
                  queue_id: responseAfterCheckQueue.data.data.queue_id,
                  file_name: responseAfterCheckQueue.data.data.file,
                },
              }
            );

            const url = window.URL.createObjectURL(resultDownload.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              responseAfterCheckQueue.data.data.file
            );
            document.body.appendChild(link);
            link.click();
          }
        } else {
          // display error
          this.dialogErrorTitle = "";
          this.dialogError = true;
          this.errorText = `ไม่สามารถดาวโหลดรายงานได้`;
        }

        this.togglePreLoader(false);
      }
    },
    clearAll() {
      this.selYear = this.appInfo.data.ENROLL_ACADYEAR;
      this.selSemester = this.appInfo.data.ENROLL_SEMESTER;
      this.selLvl = 3;
      this.selFaculty = 0;
      this.handleClrScreen();
      this.selPeriod = "A";
    },
    handleSearchAdvisorKey(event) {
      if (event.charCode == 13) {
        this.handleSearchAdvisor();
      }
    },
    async handleSearchAdvisor() {
      this.dlgIdentity = this.advisorCode;
      this.dialogSearchAdvisor = true;
      this.bTableAdvisor.items = [];
      this.selunderFac = "";
      //   if (this.advisorCode != "") {
      //     this.togglePreLoader(true);
      //     const result = await enrollProvider.getCoordinatorbyofficer({
      //     token: this.token,
      //     request: {
      //       officercode: this.dlgIdentity,
      //       officername: this.dlgFullname,
      //       facultyid: this.selunderFac,
      //       lang: this.currentLang,
      //     },
      //   });
      //     // Fix Dropdown Course List Found Multiple Course
      //     if (result.status != 500 && result.data.length > 0) {
      //       if (result.data.length === 0) {
      //         this.handleSelectClass(result[0]);
      //         this.courseList = result;
      //       } else {
      //         this.courseList = result;
      //         this.dlgIdentity = this.advisorCode;
      //         this.dialogSearchAdvisor = true;
      //         this.bTableAdvisor.items = [];
      //         if (result.data.length > 0) {
      //           let idx = 0;
      //           result.data.map((d) => {
      //             d.rowNumber = idx + 1;
      //             this.bTableAdvisor.items.push(d);
      //             idx++;
      //           });
      //         }
      //       }
      //     }else {
      //       this.dialogError = true;
      //     this.errorText = result.message;
      //     }
      //     this.togglePreLoader(false);
      //   } else {
      //     this.handleShowDlgSearchCourse();
      //   }
    },
    handleShowDlgSearchCourse() {
      this.clearAdvisor();
      this.dialogSearchAdvisor = true;
    },
    async handleSelectAdv(item) {
      if (item && item.OFFICERCODE !== null) {
        this.advisorCode = item.OFFICERCODE;
        this.advisorName = item.NAME;
      }
    },
    handleClrScreen() {
      this.advisorCode = "";
      this.advisorName = "";
    },
    async handleAdvisorSearch() {
      if (this.selunderFac != "") {
        this.togglePreLoader(true);
        const result = await enrollProvider.getCoordinatorbyofficer({
          token: this.token,
          request: {
            officercode: this.dlgIdentity,
            officername: this.dlgFullname,
            facultyid: this.selunderFac,
            lang: this.currentLang,
          },
        });
        this.bTableAdvisor.items = [];
        if (result.length > 0) {
          let idx = 0;
          const temp = result.map((d, idx) => {
            return {
              ...d,
              rowNumber: idx + 1,
            };
          });
          this.bTableAdvisor.items = temp;
        } else {
          this.dialogError = true;
          this.errorText = result.message;
        }
        this.togglePreLoader(false);
      } else {
        return;
        // this.dialogErrorTitle = "";
        // this.dialogError = true;
        // this.errorText = `${result.message}`;
      }
    },
    clearAdvisor() {
      this.dlgIdentity = "";
      this.dlgFullname = "";
      this.selunderFac = 0;
      this.bTableAdvisor.items = [];
    },
    async handleSelectAdvisor(item, idx) {
      console.log(idx);
      this.courseId = item.CLASSID;
      this.courseCode = item.COURSECODE;
      this.courseName = item.COURSENAME;
      this.handleSelectAdv(item); //ส่งค่า id ปุ่มฟ้า
      this.dialogSearchAdvisor = false;
    },
  },
  watch: {
    async currentLang() {
      this.bTableAdvisor.fields = [
        {
          key: "rowNumber",
          label: this.$t("messages.general.seqOrder"),
          thClass: "align-middle",
          thStyle: "width: 50px",
          sortable: true,
        },
        {
          key: "OFFICERCODE",
          label: this.$t("messages.general.identity"),
          thClass: "align-middle",
          thStyle: "width: 120px",
          sortable: true,
        },
        {
          key: "NAME",
          label: this.$t("messages.general.fullname"),
          thClass: "align-middle",
          thStyle: "width: 250px",
          tdClass: "text-left text-nowarp",
          sortable: true,
        },
        {
          key: "FACULTYNAME",
          label: this.$t("messages.general.underFac"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
        {
          key: "GENDER",
          label: this.$t("messages.general.gender"),
          thClass: "align-middle",
          thStyle: "width: 150px",
          tdClass: "text-center text-nowarp",
          sortable: true,
        },
      ];
    },
  },
};
</script>
